import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import logo from 'images/engagement-survey-logo.png';
import i18n from 'i18next';
import './styles.scss';

const EngagementSurveyHeader = ({
    shouldHideRightLabel, logoUrl, loadingLogo, progressTracker
}) => {
    return (
        <div className='engagement-survey-header-container'>
            <div className='fl-header-logo'>
                {loadingLogo ? (
                    <React.Fragment />
                ) : (
                    <img src={ logoUrl || logo } alt='flow logo' />
                )}
            </div>
            {!shouldHideRightLabel && (
                <div className='title-progress-container'>
                    <h1>{i18n.t('engagement.engagement_survey').toUpperCase()}</h1>
                    {progressTracker}
                </div>
            )}
        </div>
    );
};

EngagementSurveyHeader.propTypes = {
    shouldHideRightLabel: PropTypes.bool,
    logoUrl: PropTypes.string,
    loadingLogo: PropTypes.bool,
    progressTracker: PropTypes.element
};

EngagementSurveyHeader.defaultProps = {
    shouldHideRightLabel: null,
    logoUrl: null,
    loadingLogo: true
};

const mapStateToProps = state => ({
    logoUrl: state.logoReducer.get('logoUrl'),
    loadingLogo: state.logoReducer.get('loadingLogo')
});


export default connect(mapStateToProps, null)(EngagementSurveyHeader);
